(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderMegaMenuV2 extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('[data-mega-menu-details]');
      this.summary = this.details?.querySelector('summary');
      this.panel = this.details?.querySelector('.mega-menu-v2__panel');
      this.openDelay = Number(this.dataset.openDelay) || 150;
      this.closeDelay = Number(this.dataset.closeDelay) || 220;
      this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.onPointerEnterHandler = this.onPointerEnter.bind(this);
      this.onPointerLeaveHandler = this.onPointerLeave.bind(this);
      this.onFocusInHandler = this.onFocusIn.bind(this);
      this.onFocusOutHandler = this.onFocusOut.bind(this);
      this.onKeyUpHandler = this.onKeyUp.bind(this);
      this.onToggleHandler = this.onToggle.bind(this);
      this.onDocumentClickHandler = this.onDocumentClick.bind(this);
      this.onBlockSelectHandler = this.onBlockSelect.bind(this);
      this.onBlockDeselectHandler = this.onBlockDeselect.bind(this);
    }

    connectedCallback() {
      if (!this.details || !this.summary || !this.panel) return;

      this.addEventListener('pointerenter', this.onPointerEnterHandler);
      this.addEventListener('pointerleave', this.onPointerLeaveHandler);
      this.addEventListener('focusin', this.onFocusInHandler);
      this.addEventListener('focusout', this.onFocusOutHandler);
      this.addEventListener('keyup', this.onKeyUpHandler);
      this.details.addEventListener('toggle', this.onToggleHandler);
      document.addEventListener('click', this.onDocumentClickHandler);
      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', this.onBlockSelectHandler);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselectHandler);
      }
      this.syncExpandedState();
    }

    disconnectedCallback() {
      window.clearTimeout(this.openTimer);
      window.clearTimeout(this.closeTimer);
      this.removeEventListener('pointerenter', this.onPointerEnterHandler);
      this.removeEventListener('pointerleave', this.onPointerLeaveHandler);
      this.removeEventListener('focusin', this.onFocusInHandler);
      this.removeEventListener('focusout', this.onFocusOutHandler);
      this.removeEventListener('keyup', this.onKeyUpHandler);
      this.details?.removeEventListener('toggle', this.onToggleHandler);
      document.removeEventListener('click', this.onDocumentClickHandler);
      this.removeEventListener('shopify:block:select', this.onBlockSelectHandler);
      this.removeEventListener('shopify:block:deselect', this.onBlockDeselectHandler);
    }

    onPointerEnter() {
      if (!this.canHover.matches) return;

      window.clearTimeout(this.closeTimer);
      this.openTimer = window.setTimeout(() => this.open(), this.openDelay);
    }

    onPointerLeave() {
      if (!this.canHover.matches) return;

      window.clearTimeout(this.openTimer);
      this.closeTimer = window.setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      }, this.closeDelay);
    }

    onFocusIn() {
      window.clearTimeout(this.closeTimer);
      this.open();
    }

    onFocusOut() {
      window.setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE' || !this.details.open) return;

      event.preventDefault();
      this.close();
      this.summary.focus();
    }

    onDocumentClick(event) {
      if (this.details.open && !this.contains(event.target)) this.close();
    }

    onBlockSelect() {
      this.open();
    }

    onBlockDeselect() {
      this.close();
    }

    onToggle() {
      this.syncExpandedState();

      if (this.details.open) {
        this.closeOtherMenus();
        this.hydrateImages();
      }
    }

    open() {
      window.clearTimeout(this.closeTimer);
      if (this.details.open) return;

      this.details.open = true;
    }

    close() {
      window.clearTimeout(this.openTimer);
      if (!this.details.open) return;

      this.details.open = false;
    }

    closeOtherMenus() {
      document
        .querySelectorAll('header-mega-menu-v2 details[open], header-menu details[open], products-mega-menu details[open]')
        .forEach((details) => {
          if (details === this.details) return;
          details.open = false;
          details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        });
    }

    syncExpandedState() {
      this.summary.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
      this.toggleAttribute('data-open', this.details.open);
    }

    hydrateImages() {
      this.querySelectorAll('img[data-mega-menu-src]').forEach((image) => {
        if (image.dataset.megaMenuSrcset) image.srcset = image.dataset.megaMenuSrcset;
        image.src = image.dataset.megaMenuSrc;
        image.removeAttribute('data-mega-menu-src');
        image.removeAttribute('data-mega-menu-srcset');
      });
    }
  }

  if (!customElements.get('header-mega-menu-v2')) {
    customElements.define('header-mega-menu-v2', HeaderMegaMenuV2);
  }

  const setupHeaderDrawer = (host, setHeaderHeight) => {
    const drawer = host.querySelector('header-drawer');
    const rootDetails = drawer?.querySelector('#Details-menu-drawer-container');
    const desktopMediaQuery = window.matchMedia('(min-width: 990px)');

    if (!drawer || !rootDetails) return () => {};

    const nestedDetails = Array.from(drawer.querySelectorAll('details')).filter((details) => details !== rootDetails);
    const legacyMegaMenus = Array.from(host.querySelectorAll('products-mega-menu'));

    const hydrateImages = (container) => {
      container.querySelectorAll('img[data-mega-menu-src]').forEach((image) => {
        if (image.dataset.megaMenuSrcset) image.srcset = image.dataset.megaMenuSrcset;
        image.src = image.dataset.megaMenuSrc;
        image.removeAttribute('data-mega-menu-src');
        image.removeAttribute('data-mega-menu-srcset');
      });
    };

    const hydratePanelImages = (event) => {
      if (!event.currentTarget.open) return;
      hydrateImages(event.currentTarget);
    };

    const legacyMegaMenuHandlers = legacyMegaMenus.map((menu) => {
      const details = menu.querySelector('details');
      const summary = details?.querySelector('summary');

      if (!details || !summary) return null;

      const handleToggle = () => {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        if (details.open) hydrateImages(details);
      };
      const handleFocusIn = () => {
        details.open = true;
      };
      const handleFocusOut = () => {
        window.setTimeout(() => {
          if (!menu.contains(document.activeElement)) details.open = false;
        });
      };
      const handleKeyUp = (event) => {
        if (event.code.toUpperCase() !== 'ESCAPE' || !details.open) return;
        details.open = false;
        summary.focus();
      };

      details.addEventListener('toggle', handleToggle);
      menu.addEventListener('focusin', handleFocusIn);
      menu.addEventListener('focusout', handleFocusOut);
      menu.addEventListener('keyup', handleKeyUp);

      return { details, menu, handleToggle, handleFocusIn, handleFocusOut, handleKeyUp };
    });

    const resetDrawer = () => {
      if (rootDetails.open) return;

      drawer.querySelectorAll('.menu-drawer, .menu-drawer__submenu').forEach((panel) => {
        panel.scrollTop = 0;
      });
    };

    const handleViewportChange = (event) => {
      setHeaderHeight();
      if (!event.matches || !rootDetails.open) return;

      const opener = rootDetails.querySelector('summary');
      if (typeof drawer.closeMenuDrawer === 'function') {
        drawer.closeMenuDrawer(new Event('resize'), opener);
      } else {
        rootDetails.removeAttribute('open');
        opener?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-desktop');
      }
    };

    rootDetails.addEventListener('toggle', resetDrawer);
    nestedDetails.forEach((details) => details.addEventListener('toggle', hydratePanelImages));
    desktopMediaQuery.addEventListener('change', handleViewportChange);

    return () => {
      rootDetails.removeEventListener('toggle', resetDrawer);
      nestedDetails.forEach((details) => details.removeEventListener('toggle', hydratePanelImages));
      desktopMediaQuery.removeEventListener('change', handleViewportChange);
      legacyMegaMenuHandlers.forEach((handler) => {
        if (!handler) return;
        handler.details.removeEventListener('toggle', handler.handleToggle);
        handler.menu.removeEventListener('focusin', handler.handleFocusIn);
        handler.menu.removeEventListener('focusout', handler.handleFocusOut);
        handler.menu.removeEventListener('keyup', handler.handleKeyUp);
      });
    };
  };

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.cleanupHeaderDrawer = setupHeaderDrawer(this, this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.cleanupHeaderDrawer?.();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu, header-mega-menu-v2, products-mega-menu');
      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') disclosure.close();
        if (typeof disclosure.closeMenu === 'function') disclosure.closeMenu();
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();
      this.cleanupHeaderDrawer = setupHeaderDrawer(this, this.setHeaderHeight.bind(this));
    }

    disconnectedCallback() {
      this.cleanupHeaderDrawer?.();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
